export default "__VITE_ASSET__BlEt_Y2c__"